import * as Sentry from "@sentry/react-native";
import { isRunningInExpoGo } from "expo";
import { environment } from "~/environment";
import { routingInstrumentation } from "~/utils/routingInstrumentation";

let isSentryInitialized = false;

export async function initializeSentry() {
  if (__DEV__) return;

  if (!environment.SENTRY_DSN) {
    console.log(
      "[Warning in initializeSentry] SENTRY_DSN is not set in .env.local file",
    );
    return;
  }

  try {
    if (!isSentryInitialized) {
      Sentry.init({
        dsn: environment.SENTRY_DSN,
        debug: false,
        environment: environment.ENVIRONMENT_NAME,
        sendDefaultPii: false,
        autoSessionTracking: true,
        enableNative: true,
        autoInitializeNativeSdk: true,
        enableNativeCrashHandling: true,
        enableAutoSessionTracking: true,
        enableNativeFramesTracking: !isRunningInExpoGo(),
        integrations: [routingInstrumentation],
      });

      isSentryInitialized = true;
    }
  } catch (error) {
    console.log("[Error in initializeSentry]", String(error));
  }
}
